import { useContext, useEffect, useState } from 'react';

import { useGraphThreadRunsForStatus } from '../api/useGraphSwr';
import { StateContext } from '../control/state';
import { isRunExecuting } from '../control/state.utils';
import { useActiveThreadId } from './useActiveThreadId';

export const useJoinRun = ({
  joinRun,
}: {
  joinRun: (runId: string) => void;
}) => {
  const { runState } = useContext(StateContext);
  const { threadId } = useActiveThreadId();
  const [hasJoinedRunForThread, setHasJoinedRunForThread] = useState<
    Record<string, boolean>
  >({});
  const [runInitiatedForThread, setRunInitiatedForThread] = useState<
    Record<string, boolean>
  >({});
  const { data: activeRuns } = useGraphThreadRunsForStatus(threadId, 'running');
  const { data: pendingRuns } = useGraphThreadRunsForStatus(
    threadId,
    'pending'
  );

  useEffect(() => {
    if (!threadId) return;
    if (isRunExecuting(runState)) {
      setRunInitiatedForThread((prev) => ({
        ...prev,
        [threadId]: true,
      }));
    }
  }, [runState]);

  // if thread is loaded and there is an active run for the thread, join it
  useEffect(() => {
    if (!threadId) return;
    if (
      (activeRuns?.length || pendingRuns?.length) &&
      !isRunExecuting(runState) &&
      // don't join if the run was initiated in the same session
      !runInitiatedForThread[threadId] &&
      !hasJoinedRunForThread[threadId]
    ) {
      const runId = activeRuns?.[0]?.run_id ?? pendingRuns?.[0]?.run_id;
      if (!runId) return;
      joinRun(runId);
      setHasJoinedRunForThread((prev) => ({
        ...prev,
        [threadId]: true,
      }));
    }
  }, [activeRuns, hasJoinedRunForThread, pendingRuns, runState]);
};
